import { Box, TableCell } from "@mui/material";
import StyledTableRow from "../../../../components/table/styled-table-row";
import { useState } from "react";
import { ConfirmationDialog } from "../../../../components/confiramation-dialog";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { selectLoggedInUser } from "../../../auth/auth.slice";
import TableActionButton from "../../../../components/table/table-action-button";
import { EditIcon, DeleteIcon } from "../../../../shared/icons";
import { MealItem, MealItemRequest } from "../../../../service/model/nutrition.model";
import { deleteMealItem, updateMealItem } from "../meal-item.slice";
import MealItemForm from "./meal-item-form";
import { UserType } from "../../../../shared/enums";

interface TableRowProps {
    readonly mealItem: MealItem
}

const MealItemTableRow: React.FC<TableRowProps> = ({ mealItem }) => {
    const dispatch = useAppDispatch();
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showMembershipForm, setShowMembershipForm] = useState(false);
    const loggedInUserDetails = useAppSelector(selectLoggedInUser);
    const loggedInUser = loggedInUserDetails?.user;

    const handleDelete = () => {
        dispatch(deleteMealItem(mealItem.id))
        setShowDeleteDialog(false)
    }

    const handleDeleteCancel = () => {
        setShowDeleteDialog(false)
    }

    const handleSubmit = (data: MealItemRequest) => {
        loggedInUser && dispatch(updateMealItem({ ...data, id: mealItem.id })).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowMembershipForm(false);
            }
        });
    };

    const isAuthorizedUser = () => {
        if (!mealItem.isGlobal) {
            if(loggedInUserDetails?.type === UserType.MEMBER) {
                return loggedInUserDetails?.roleData?.member?.id && mealItem.memberId === loggedInUserDetails?.roleData?.member?.id;
            } else if(loggedInUserDetails?.type === UserType.BUSINESS_USER) {
                return loggedInUserDetails?.roleData?.businessUser?.business?.id && mealItem.businessId === loggedInUserDetails?.roleData?.businessUser?.business?.id;
            }
        }
        return false;
    }

    const editable = isAuthorizedUser();

    return (
        <>
            <StyledTableRow key={mealItem.id}>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Name</Box>{mealItem.name}</TableCell>
                {/* <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Category</Box>{mealItem.category}</TableCell> */}
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Quantity</Box>{mealItem.defaultQuantity} {mealItem.defaultUnit?.symbol}</TableCell>
                {/* <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Unit</Box>{mealItem.defaultUnit?.name} ({mealItem.defaultUnit?.symbol})</TableCell> */}
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Calories (cal)</Box>{mealItem.nutrition.calories}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Protein (g)</Box>{mealItem.nutrition.protein}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Carbs (g)</Box>{mealItem.nutrition.carbohydrates}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Fat (g)</Box>{mealItem.nutrition.fat}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Fiber (g)</Box>{mealItem.nutrition.fiber}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Sugar (g)</Box>{mealItem.nutrition.sugar}</TableCell>
                <TableCell>
                    <Box component="div" display="inline" className="responsive-mobile-heading">Actions</Box>
                    <TableActionButton onClick={() => setShowMembershipForm(true)} label="Edit" icon={<EditIcon />} disabled={!editable} />
                    <TableActionButton onClick={() => setShowDeleteDialog(true)} label="Delete" icon={<DeleteIcon />} disabled={!editable} />
                </TableCell>
            </StyledTableRow>
            {showMembershipForm &&
                <MealItemForm mealItem={mealItem} editable={true} onClose={() => setShowMembershipForm(false)} onSubmit={handleSubmit} />
            }
            {showDeleteDialog &&
                <ConfirmationDialog show={true} message="Are you sure you want to delete?" onConfirm={handleDelete} onCancel={handleDeleteCancel} />
            }
        </>
    );
}

export default MealItemTableRow;